import * as React from "react";

import { Box, makeStyles } from "@material-ui/core";

import loginHero from "client/assets/login-hero.png";
import loginRect from "client/assets/login-rectangle.png";

const useStyles = makeStyles(() => ({
  heroImages: {
    width: "100%",
  },
}));

export const LoginHero: React.FC = () => {
  const classes = useStyles();
  return (
    <Box position="relative">
      <Box position="absolute">
        <img
          className={classes.heroImages}
          src={loginRect}
          alt="background image"
        />
      </Box>
      <Box position="absolute" top="5rem" left="4rem">
        <img
          className={classes.heroImages}
          src={loginHero}
          alt="girl standing"
        />
      </Box>
    </Box>
  );
};
